import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from './card.js';
import { Table } from './table.js';
import { renderTableHeader } from './table-actions-column.js';
function isColumnList(props) {
    return props.headerCells !== undefined;
}
/**
 * `Card` + `Table` shell for a list page's loading skeleton: real header,
 * `Table.Loading` rows in the body. Extracted from ~8 sites that repeated this
 * wrapper around a page-specific header (FP-18/FP-28 dedup, Ruling R10).
 */
export function LoadingTableCard(props) {
    const { rows, density = 'compact' } = props;
    const { header, colSpan } = isColumnList(props)
        ? {
            header: renderTableHeader(props.headerCells, props.actionsColumn),
            colSpan: props.headerCells.length + (props.actionsColumn ? 1 : 0),
        }
        : { header: props.header, colSpan: props.colSpan };
    return (_jsx(Card, { className: "overflow-hidden", children: _jsxs(Table, { density: density, children: [header, _jsx(Table.Body, { children: _jsx(Table.Loading, { colSpan: colSpan, ...(rows !== undefined ? { rows } : {}) }) })] }) }));
}
//# sourceMappingURL=loading-table-card.js.map